import { IonButton, IonContent, IonGrid } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import XLSX from "xlsx";
import { AppHeader } from "../../../../components/Header/AppHeader";
import { getEntries } from "../../../../services/users";
import XLSXOutputTable from "./XLSXOutputTable";
import { Grid } from "react-virtualized";
import DownloadData from "./DownloadData";

//https://www.npmjs.com/package/react-virtualized

export interface RouteParams {
	id: string;
}

interface props {
	users: any;
}

const UserDataTable: React.FC<props> = ({ users }) => {
	let { id } = useParams<RouteParams>();

	const [user, setUser] = useState<any>({});
	const [sheetData, setSheetData] = useState<any>([]);
	const [sheetCols, setSheetCols] = useState<any>([]);
	const [entries, setEntries] = useState<any>([]);

	useEffect(() => {
		if (users && users[id]) {
			setUser(users[id]);
		}
		//eslint-disable-next-line
	}, [users]);

	useEffect(() => {
		getEntries(id).then((data: any) => {
			setEntries(data);
		});
		//eslint-disable-next-line
	}, [user]);

	useEffect(() => {
		if (entries) {
			_setupData(id);
		}
		//eslint-disable-next-line
	}, [entries]);

	const exportFile = (data: any) => {
		/* convert state to workbook */
		const ws = XLSX.utils.aoa_to_sheet(data);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Data");
		/* generate XLSX file and send to client */
		let TS = new Date().toISOString();
		XLSX.writeFile(wb, `${user.displayName}-${user.study}-${TS}.xlsx`);
	};

	const _setupData = (uid: any) => {
		// //console.log(entries);

		// let cols = [
		// 	{ name: "A", key: 0 },
		// 	{ name: "B", key: 1 },
		// 	{ name: "C", key: 2 },
		// 	{ name: "D", key: 3 },
		// 	{ name: "E", key: 4 },
		// 	{ name: "F", key: 5 },
		// 	{ name: "B", key: 6 },
		// 	{ name: "C", key: 7 },
		// 	{ name: "D", key: 8 },
		// 	{ name: "E", key: 9 },
		// 	{ name: "F", key: 10 },
		// 	{ name: "G", key: 11 },
		// 	{ name: "H", key: 12 },
		// 	{ name: "I", key: 13 },
		// 	{ name: "J", key: 14 },
		// 	{ name: "K", key: 15 },
		// 	{ name: "L", key: 16 },
		// 	{ name: "M", key: 17 },
		// 	{ name: "N", key: 18 },
		// 	{ name: "O", key: 19 },
		// 	{ name: "P", key: 20 },
		// 	{ name: "Q", key: 21 },
		// 	{ name: "F", key: 22 },
		// 	{ name: "S", key: 23 },
		// 	{ name: "T", key: 24 },
		// 	{ name: "U", key: 25 },
		// 	{ name: "V", key: 26 },
		// 	{ name: "W", key: 27 },
		// 	{ name: "X", key: 28 },
		// 	{ name: "Y", key: 29 },
		// 	{ name: "Z", key: 30 },
		// 	{ name: "AA", key: 31 },
		// 	{ name: "AB", key: 32 },
		// 	{ name: "AC", key: 33 },
		// 	{ name: "AD", key: 34 },
		// 	{ name: "AE", key: 35 },
		// 	{ name: "AF", key: 36 },
		// 	{ name: "AG", key: 37 },
		// 	{ name: "AH", key: 38 },
		// 	{ name: "AI", key: 39 },
		// ];

		let headers = [
			"Date",
			"Meal",
			"TF1 - Food",
			"TF1 - Amount Offered",
			"TF1 - Amount Offered Unit",
			"TF1 - Amount Consumed",
			"TF1 - Amount Consumed Unit",
			"TF1 - Acceptance",
			"TF1 - Bites Consumed",
			"TF2 - Food",
			"TF2 - Amount Offered",
			"TF2 - Amount Offered Unit",
			"TF2 - Amount Consumed",
			"TF2 - Amount Consumed Unit",
			"TF2 - Acceptance",
			"TF2 - Bites Consumed",
			"TF3 - Food",
			"TF3 - Amount Offered",
			"TF3 - Amount Offered Unit",
			"TF3 - Amount Consumed",
			"TF3 - Amount Consumed Unit",
			"TF3 - Acceptance",
			"TF3 - Bites Consumed",
			"TF4 - Food",
			"TF4 - Amount Offered",
			"TF4 - Amount Offered Unit",
			"TF4 - Amount Consumed",
			"TF4 - Amount Consumed Unit",
			"TF4 - Acceptance",
			"TF4 - Bites Consumed",
			"TF5 - Food",
			"TF5 - Amount Offered",
			"TF5 - Amount Offered Unit",
			"TF5 - Amount Consumed",
			"TF5 - Amount Consumed Unit",
			"TF5 - Acceptance",
			"TF5 - Bites Consumed",
			"Behaviour",
			"Image Pre",
			"Image Post",
		];

		let data = [headers];

		Object.values(entries).forEach((en: any, idx: any) => {
			let res = [];

			res.push(en.date, en.meal);

			let i = 0;
			while (i < 5) {
				let food = en.targetFood[i];
				if (food) {
					res.push(
						food.food,
						food.amountOfferedQTY,
						food.amountOfferedUnit,
						food.amountConsumedQTY,
						food.amountConsumedUnit,
						food.acceptance,
						food.numberBitesConsumed
					);
				} else {
					res.push("", "", "", "", "", "", "");
				}
				i++;
			}
			res.push(en.mealtimeBehaviour, en.imagePreURL, en.imagePostURL);
			data.push(res);
		});

		setSheetData(data);
		//setSheetCols(cols);
	};

	// const cellRenderer = ({ columnIndex, key, rowIndex, style }: any) => {
	// 	return (
	// 		<div key={key} style={style}>
	// 			{sheetData[rowIndex][columnIndex]}
	// 		</div>
	// 	);
	// };

	return (
		<>
			<AppHeader title={user && user.displayName} />
			<IonContent fullscreen className="ion-padding">
				<DownloadData id={id} />

				{/* {console.log(sheetData[0].length)} */}
				{/* {sheetData.length && (
					<Grid
						cellRenderer={cellRenderer}
						columnCount={sheetData[0].length}
						columnWidth={100}
						height={300}
						rowCount={sheetData.length}
						rowHeight={60}
						width={1000}
						// autoWidth={true}
					/>
				)} */}
			</IonContent>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	users: state.user.users,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserDataTable);
